
import { mapGetters } from 'vuex'
export default {
  name: 'TeflComparisonTable',
  data() {
    return {
      activeTab: 'The TEFL Org',
      courses: {
        online: {
          uk: [
            {
              name: "The TEFL Org",
              price: "£379 - £606",
              discounted: "£151.60 - £242.40",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "i-to-i",
              price: "£395 - £1,795",
              discounted: "£99 - £449",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "10 weeks",
              certificate: "PDF included, £29.95 hardcopy",
            },
            {
              name: "The TEFL Academy",
              price: "£373 - £573",
              discounted: "£149 - £229",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "£354 - £745",
              discounted: "£120 - £325",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, £25 per hardcopy",
            },
            {
              name: "UK TEFL",
              price: "£225 - £300",
              discounted: "-",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: false,
              accreditors: "TQUK endorsed but not regulated",
              time: "90 days",
              certificate: "PDF certificate included. Hardcopy TEFL certificate from £15",
            },
            {
              name: "Groupon TEFL Courses",
              price: "Varies ~ £20",
              discounted: "-",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: false,
              accreditors: "Often not accredited",
              time: "Varies depending on provider",
              certificate: "Not included",
            },
          ],
          eu: [
            {
              name: "The TEFL Org",
              price: "€459 - €722",
              discounted: "€183.60 - €288.80",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "i-to-i",
              price: "€429 - €2,595",
              discounted: "€109 - €649",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "10 weeks",
              certificate: "PDF included, €39.95 hardcopy",
            },
            {
              name: "The TEFL Academy",
              price: "€413 - €663",
              discounted: "€165 - €265",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "€389 - €875",
              discounted: "€120 - €375",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, €25 per hardcopy",
            },
            {
              name: "The TEFL Institute of Ireland",
              price: "€415 - €875",
              discounted: "€175 - €375",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "3",
              time: "6 months",
              certificate: "Digital certificate, €25 for a copy (disc. on multiples)",
            },
            {
              name: "UK TEFL",
              price: "-",
              discounted: "-",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: false,
              accreditors: "TQUK endorsed but not regulated",
              time: "90 days",
              certificate: "PDF certificate included. Hardcopy TEFL certificate from €x",
            },
            {
              name: "Groupon TEFL Courses",
              price: "~€30",
              discounted: "-",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: false,
              accreditors: "Often not accredited",
              time: "Varies depending on provider",
              certificate: "Not included",
            },
          ],
          us: [
            {
              name: "The TEFL Org",
              price: "$549 - $849",
              discounted: "$274.50 - $424.50",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "i-to-i",
              price: "$429 - $2,595",
              discounted: "$109 - $649",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "10 weeks",
              certificate: "PDF included, $39.95 hardcopy",
            },
            {
              name: "The TEFL Academy",
              price: "$563 - $743",
              discounted: "$225 - $297",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "$461 - $1,015",
              discounted: "$120 - $465",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, $30 per hardcopy",
            },
            {
              name: "International TEFL Academy",
              price: "$1,649",
              discounted: "$1,549",
              ofqual: true,
              deac: false,
              ownedAndRun: false,
              support: true,
              accreditors: "1",
              time: "11 weeks (170 hour course)",
              certificate: "PDF only, no hardcopies",
            },
            {
              name: "Bridge TEFL",
              price: "$710",
              discounted: "$419",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: true,
              accreditors: "3",
              time: "3 months",
              certificate: "PDF included, $75 per hard copy",
            },
            {
              name: "Groupon TEFL Courses",
              price: "~ $20",
              discounted: "-",
              ofqual: false,
              deac: false,
              ownedAndRun: false,
              support: false,
              accreditors: "Often not accredited",
              time: "Varies depending on provider",
              certificate: "Not included",
            },
          ],
        },
        combined: {
          uk: [
            {
              name: "The TEFL Org",
              price: "£549 - £936",
              discounted: "£274.50 - £468",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "Up to 7 months",
              certificate: "Both included",
            },
            {
              name: "The TEFL Academy",
              price: "£823",
              discounted: "£329",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "£455 - £885",
              discounted: "£205 - £365",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, £25 per hardcopy",
            },
          ],
          eu: [
            {
              name: "The TEFL Org",
              price: "€649 - €1,092",
              discounted: "€324.50 - €546",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "Up to 7 months",
              certificate: "Both included",
            },
            {
              name: "The TEFL Academy",
              price: "€913",
              discounted: "€365",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "€545 - €1,005",
              discounted: "€245 - €445",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, €25 per hardcopy",
            },
            {
              name: "The TEFL Institute of Ireland",
              price: "€745 - €945",
              discounted: "€345 - €445",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "3",
              time: "6 months",
              certificate: "Digital included",
            },
          ],
          us: [
            {
              name: "The TEFL Org",
              price: "$709 - $1,009",
              discounted: "$354.50 - $504.50",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "Up to 7 months",
              certificate: "Both included",
            },
            {
              name: "The TEFL Academy",
              price: "$1,080",
              discounted: "$432",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
            },
            {
              name: "Premier TEFL",
              price: "$565 - $1,165",
              discounted: "$255 - $535",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, $30 per hardcopy",
            },
          ],
        },
        level5: {
          uk: [
            {
              name: "The TEFL Org",
              price: "£606 - £936",
              discounted: "£242.40 - £468",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "7 months",
              certificate: "Both included",
              teaching: "220 and 230 hours options",
              certOrDip: "Diploma",
            },
            {
              name: "i-to-i",
              price: "£665 - £1,795",
              discounted: "£166 - £449",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "up to 47 weeks depending on course",
              certificate: "PDF included, £29.95 hardcopy",
              teaching: "No",
              certOrDip: "Certificate and Diploma-level courses available",
            },
            {
              name: "The TEFL Academy",
              price: "£573 - £823",
              discounted: "£229 - £329",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
              teaching: "Combined option",
              certOrDip: "Diploma",
            },
            {
              name: "Premier TEFL",
              price: "£525 - £885",
              discounted: "£205 - £365",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, £25 per hardcopy",
              teaching: "Yes",
              certOrDip: "Certificate and Diploma-level courses available",
            },
          ],
          eu: [
            {
              name: "The TEFL Org",
              price: "€722 - €1,092",
              discounted: "€288.80 - €546",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "7 months",
              certificate: "Both included",
              teaching: "220 and 230 hours options",
              certOrDip: "Diploma",
            },
            {
              name: "i-to-i",
              price: "€759 - €2,595",
              discounted: "€189 - €649",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "up to 47 weeks depending on course",
              certificate: "PDF included, €39.95 hardcopy",
              teaching: "No",
              certOrDip: "Certificate and Diploma-level courses available",
            },
            {
              name: "The TEFL Academy",
              price: "€663 - €913",
              discounted: "€265 - €365",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
              teaching: "Combined option",
              certOrDip: "Diploma",
            },
            {
              name: "Premier TEFL",
              price: "€565 - €1,005",
              discounted: "€245 - €445",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, €25 per hardcopy",
              teaching: "Yes",
              certOrDip: "Certificate and Diploma-level courses available",
            },
            {
              name: "The TEFL Institute of Ireland",
              price: "€635 - €945",
              discounted: "€225 - €445",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "3",
              time: "6 months",
              certificate: "Digital copy",
              teaching: "190-hour + 310-hour Hybrid Options",
              certOrDip: "Diploma",
            },
          ],
          us: [
            {
              name: "The TEFL Org",
              price: "$849 - $1,069",
              discounted: "$424.50 - $534.50",
              ofqual: true,
              deac: true,
              ownedAndRun: true,
              support: true,
              accreditors: "4",
              time: "7 months",
              certificate: "Both included",
              teaching: "270 and 280 hours options",
              certOrDip: "Diploma",
            },
            {
              name: "i-to-i",
              price: "$759 - $2,595",
              discounted: "$189 - $649",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "up to 47 weeks depending on course",
              certificate: "PDF included, $39.95 hardcopy",
              teaching: "No",
              certOrDip: "Certificate and Diploma-level courses available",
            },
            {
              name: "The TEFL Academy",
              price: "$743 - $1,080",
              discounted: "$297 - $432",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: false,
              accreditors: "2",
              time: "6 months",
              certificate: "Both included",
              teaching: "Combined option",
              certOrDip: "Diploma",
            },
            {
              name: "Premier TEFL",
              price: "$635 - $1,165",
              discounted: "$335 - $535",
              ofqual: true,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "4",
              time: "6 months",
              certificate: "PDF included, $30 per hardcopy",
              teaching: "Yes",
              certOrDip: "Certificate and Diploma-level courses available",
            },
            {
              name: "International TEFL Academy",
              price: "$1,649 - $1,899",
              discounted: "$1,549 - $1,899",
              ofqual: false,
              deac: true,
              ownedAndRun: false,
              support: true,
              accreditors: "1",
              time: "4 weeks full-time (180 hour course) or 11 weeks (170 hour course)",
              certificate: "PDF only, no hardcopies",
              teaching: "Yes",
              certOrDip: "Certificate",
            },
          ],
        },
      },

    }
  },
  computed:{
    ...mapGetters({
      // region: 'user/region',
      price_label: 'cart/getPriceLabel',
      page: 'pages/getPage'
    }),
    region() {
      if(this.price_label === "TEFLORG") {
        return "uk"
      }
      if(this.price_label === "IRELAND") {
        return "eu"
      }
      else {return "us"}
    },
    path() {
      if(this.page === "level-5"){
        return "level5"
      }
      if(this.page === "online" || this.page === "advanced" || this.page === "classroom"){
        return "online"
      }
      if (this.page === "combined" || this.page === "virtual"){
        return "combined"
      }
      else {return "online"}

    }
  },

  methods: {
    isActive(tableTab) {
      return this.activeTab === tableTab
    },
    setActive(tableTab) {
      this.activeTab = tableTab
    },
  },
}



// export default {
//   name: 'TeflComparisonTable',
//   props: {
//     country: {
//       type: String,
//       default: 'uk',
//     },
//   },
//   data() {
//     return {
//       activeTab: 'tefl',
//     }
//   },
//   methods: {
//     isActive(tableTab) {
//       return this.activeTab === tableTab
//     },
//     setActive(tableTab) {
//       this.activeTab = tableTab
//     },
//   },
// }
